import { faBroom, faFilter } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Link } from '@/components/ui/link/link.component';
import { Modal } from '@/components/ui/modal.component';
import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';
import { AlphabetLetterEnum } from '@/types/enums/alphabet.enum';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { alphabet } from '@/utils/consts/alphabet.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

const config = {
  title: 'Filtrar parceiros por letra',
  baseUrl: '/rede-de-atendimento',
};

interface ModalFilterByLetterProps {
  open: boolean;
  selectedLetter?: string;
  count: Record<AlphabetLetterEnum, number>;
  onOpenChange: (isOpen: boolean) => void;
}

export function ModalFilterByLetter({
  open,
  selectedLetter = '',
  count,
  onOpenChange,
}: ModalFilterByLetterProps) {
  const filteredAlphabet = alphabet.filter((letter) => count[letter] > 0);

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Content
        className="px-3 py-5"
        slotHeader={(
          <div className="flex justify-between gap-3 pb-0 items-start w-full">
            <div className="flex items-start gap-3 ml-2">
              <Icon icon={faFilter} size="lg" className="text-green-400 mt-1" />
              <Typography
                variant={TypographyVariant.MODAL_TITLE}
                className="text-left font-extrabold"
              >
                {config.title}
              </Typography>
            </div>
            <Modal.Close
              asChild
              className="self-start"
            >
              <ModalCloseButton skipInitialFocus data-testid={DataTestIdEnum.CLOSE_MODAL_FILTER_BY_LETTER} />
            </Modal.Close>
          </div>
        )}
      >
        <div className="mt-4 px-2 grid grid-cols-5 gap-x-3 gap-y-3">
          {filteredAlphabet.map((letter) => (
            <div key={letter}>
              <Button
                variant={selectedLetter === letter ? 'default' : 'secondary'}
                asChild
              >
                <Link
                  prefetch={false}
                  href={`${config.baseUrl}/por-letra/${letter.toLocaleLowerCase()}/`}
                  className="text-lg"
                >
                  {letter.toUpperCase()}
                </Link>
              </Button>
            </div>
          ))}
        </div>

        {selectedLetter && (
          <div className="mt-6">
            <Button variant="text" startIcon={faBroom} asChild>
              <Link
                prefetch={false}
                href={config.baseUrl}
                data-testid={DataTestIdEnum.BUTTON_CLEAR_FILTER}
                data-analytics-event={AnalyticsEnum.CLICK_CLEAR_FILTER_PARTNERS_INDEX}
              >
                Limpar filtro
              </Link>
            </Button>
          </div>
        )}
      </Modal.Content>
    </Modal>
  );
}
